import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../../components/layout/DashboardLayout";

const NAV = [
  { to: "/staff",       label: "My Queue", icon: "🎫", end: true },
  { to: "/staff/stats", label: "My Performance", icon: "📊" },
];

export default function StaffLayout() {
  return (
    <DashboardLayout navItems={NAV} sectionLabel="Staff">
      <Outlet />
    </DashboardLayout>
  );
}
